import { compose, mdsWidget } from 'dojo/_base/declare';
import lang from 'dojo/_base/lang';
import on from 'dojo/on';
import domConstructTyped from 'dojo/dom-construct';
import domAttr from 'dojo/dom-attr';
import domClass from 'dojo/dom-class';
import domStyle from 'dojo/dom-style';
import _WidgetBaseSP from 'more/_WidgetBaseSP';
import GenericDialog from '../../../moreCore/UI/GenericDialog/GenericDialog';
import MaintenanceInfo from '../Maintenance/MaintenanceInfo';
import ExecutionChangeDlg from '../TaskExecution/ExecutionChangeDlg';
import SimpleFileUpload from '../../../moreCore/UI/SimpleFileUpload/SimpleFileUpload';
import template from './OccurrenceTaskList.html?raw';
// NOTE (JS2TS): dropped dead deps: dojo/date/locale (not used); moreCore/UI/Hintbox/HintBox and
// WidgetCollection/JDM/Occurrence/RatingDialog/RatingDialog (imported but never used in code and not in the template).
// Tabulator = runtime global; DOM-heavy → dom-construct aliased.
declare const Tabulator: any;
const domConstruct: any = domConstructTyped;

class OccurrenceTaskList extends compose(_WidgetBaseSP) {
    [key: string]: any;

    templateString: any = template;

    occurrenceID: any = null;
    _executions: any = [];
    _files: any = [];
    _showExecutions: any = [];
    isExecuter = false;

    executionChangeDlg: any = null;

    isExternalEmployee = false;

    //_flatratesData: [],
    //_materialData: [],
    //_assistantData: [],

    postMixInProperties(): void {
        super.postMixInProperties.apply(this, arguments as any);
    }
    postCreate(): void {
        super.postCreate.apply(this, arguments as any);
        this.RequestManager.silentExceptions = true;
        this._showExecutions = [];
    }

    startup(): void {
        super.startup.apply(this, arguments as any);
    }

    loadScheduledTaskExecutors(): void {
        domClass.add(this.sectionEmployeeTasks, "w3-hide");

        this._executions = [];
        this._files = [];

        this.StandbyStart();

        var url = window.appRoot + "JDM/GetMyTasksJSON";

        if (this.occurrenceID == null || typeof (this.occurrenceID) == "undefined") {
            return
        }

        domClass.remove(this.sectionEmployeeTasks, "w3-hide");

        this.RequestManager.post(
            url,
            {
                occurrenceID: this.occurrenceID
            },
            lang.hitch(this, "_onLoadScheduledTaskExecutorsResponse"),
            lang.hitch(this, "_onLoadScheduledTaskExecutorsError"),
            false // sync
        );
    }

    _onLoadScheduledTaskExecutorsResponse(taskList: any): void {
        this.StandbyStop();

        //console.log("taskresponse", taskList);
        if (taskList.length > 0) {
            domClass.remove(this.employeeTasksContainer, "w3-hide");
        } else {
            domClass.remove(this.employeeTasksContainer, "w3-hide");
            domConstruct.empty(this.employeeTasksContainer);
            domConstruct.create("div", {
                style: {
                    "fontStyle": "italic"
                },
                className: "w3-text-gray",
                "innerHTML": this.translations["_general__noEntries"]//"keine Einträge"
            }, this.employeeTasksContainer)
            return;
        }

        let columns: any[] = [
            {
                title: this.translations["OccurrenceTaskList__TableCol_Number"]/*"Nummer"*/, field: "Number", width: 100, editor: false
            }
            , {
                title: this.translations["OccurrenceTaskList__TableCol_Costcenter"]/*"Nummer"*/, field: "ref_VT_Task.ref_cost_center_co.Cost_center", width: 100, editor: false
            },
            {
                title: this.translations["OccurrenceTaskList__TableCol_Status"]/*"Status"*/, field: "ref_status.Name", width: 150, editor: false, formatter: lang.hitch(this, "tableFormatterStatus")
            },
        ];

        if (true) {
            columns.push({
                title: this.translations["OccurrenceTaskList__TableCol_Actions"]/*"Aktionen"*/, field: "ID", formatter: lang.hitch(this, "tableBtnActions"), headerSort: false
            });
        }

        // employeeTasksContainer
        this.employeeTasksTable = new Tabulator(this.employeeTasksContainer, {
            data: taskList,
            selectableCheck: lang.hitch(this, "tableSelectableCheck"),
            layout: "fitColumns",
            index: "ID", // WIESO GEHT DES NED?!
            //height: "311px",
            columns: columns,
            rowFormatter: lang.hitch(this, "_appendNestedTable"),
        });

        domStyle.set(this.employeeTasksContainer, "fontSize", "12px");

        //console.log("executions to show", this._showExecutions);
        for (var i = 0; i < this._showExecutions.length; i++) {
            this._onClick__ExpandTaskExecutor(this._showExecutions[i]);
        }
    }

    tableSelectableCheck(row: any): any {
        return false;
    }

    _appendNestedTable(row: any): void {
        var data = row.getData();
        var container = domConstruct.create("div", { className: "w3-padding w3-border-left w3-border-right w3-border-blue w3-pale-blue" });
        var heading = domConstruct.create("div", { "innerHTML": this.translations["OccurrenceTaskExecutions__Heading"]/*"Ausführungen"*/, className: "w3-medium" }, container);
        var tableDiv = domConstruct.create("div");

        domClass.add(tableDiv, "");
        domClass.add(heading, "");

        domConstruct.place(container, row.getElement());
        domConstruct.place(heading, container);
        domConstruct.place(tableDiv, container);

        let columns: any[] = [
            { title: this.translations["OccurrenceTaskExecutions__TableCol_Employee"]/*"Mitarbeiter"*/, field: "ref_employee.DispName", editor: false, formatter: lang.hitch(this, "tableFormatterEmployee") },
            { title: this.translations["OccurrenceTaskExecutions__TableCol_Status"]/*"Status"*/, field: "ref_scheduled_task_executer_status.Name", editor: false, formatter: lang.hitch(this, "tableFormatterStatus") },
        ];

        if (this.isExecuter === true) {
            columns.push({ title: this.translations["OccurrenceTaskExecutions__TableCol_History"]/*"Status"*/, field: "tmp_history_info", editor: false, width: 400 });
        }

        var subTable = new Tabulator(tableDiv, {
            data: data.TaskExecutors,
            layout: "fitColumns",
            selectableCheck: lang.hitch(this, "tableSelectableCheck"),
            //height: "111px",
            columns: columns
        });

        domStyle.set(tableDiv, "fontSize", "12px");

        subTable.getRows().forEach(function (row: any) {
            row.normalizeHeight();
        });

        this._executions.push({ node: container, ID: data.ID });

        domClass.add(container, "w3-hide");

        // FILES!
        let buttonStates = JSON.parse(data.tmp_buttonstates);
        let fileContainer = domConstruct.create("div", { className: "w3-padding w3-border-right w3-border-left w3-border-orange w3-pale-yellow w3-hide" }, row.getElement());

        this._files.push({ node: fileContainer, ID: data.ID });
        if (data.Files && buttonStates._showFiles === true) {
            if (data.Files.length > 0) {


                let heading = domConstruct.create("div",
                    {
                        "innerHTML": this.translations["OccurrenceTaskExecutions__FilesHeading"],
                        className: "w3-medium w3-border-top w3-padding-y"
                    },
                    fileContainer);

                let filesTable = domConstruct.create("div", { className: "flex_row" }, heading);


                for (let i = 0; i < data.Files.length; i++) {
                    let file = data.Files[i];

                    let fileRowDiv = domConstruct.create("div",
                        {
                            className: "flex_row_center w3-margin-right w3-light-gray ",
                            //innerHTML: file.Filename
                        },
                        filesTable);

                    domConstruct.create("span",
                        {
                            className: "w3-padding-small",
                            innerHTML: file.Filename
                        }, fileRowDiv)


                    if (file._canDownload === true) {
                        let downloadButton = domConstruct.create("button",
                            {
                                className: "mds-button-base",
                                innerHTML: "<i class='fa fa-download'></i>"
                            },
                            fileRowDiv
                        );

                        domClass.add(fileRowDiv, "mds-hover-dark");

                        on(fileRowDiv, "click", lang.hitch(this, this._onClickDownloadFile, file.ID))
                    }

                    if (file._canRemove) {
                        let removeBtn = domConstruct.create("button",
                            {
                                className: "mds-button-base w3-pale-red mds-hover-dark",
                                innerHTML: "<i class='fa fa-times w3-text-red'></i>"
                            },
                            fileRowDiv
                        );

                        on(removeBtn, "click", lang.hitch(this, this._onClick_RemoveFile, file.ID, data.ID, filesTable));
                    };
                }
            }
        }

        if (buttonStates._uploadFiles === true) {
            let uploadContainer = domConstruct.create("div", {
                className: "w3-medium w3-margin-top w3-padding-y w3-border-top",
                innerHTML: this.translations["OccurrenceTaskExecutions__FilesUploadHeading"]
            }, fileContainer);

            //let fileupload = domConstruct.create("input",
            //    {
            //        "className": "w3-block w3-padding-y",
            //        "type": "file",
            //        "multiple": "true"
            //        //"disabled": this.isReadonly === true ? "disabled" : "false",
            //    }, uploadContainer);


            let fileupload: any = new SimpleFileUpload();
            fileupload.set("MultipleMode", true);
            fileupload.set("submitCallback", lang.hitch(this, this._onUploadTaskfileResponse, row));
            fileupload.set("UploadUrl", "JDM/UploadTaskFile"); // egal, weil wir eh nicht
            fileupload.set("maxSize", 9);
            domConstruct.place(fileupload.domNode, fileContainer);

            let buttonContainer = domConstruct.create("div", {}, fileContainer);

            on(fileupload, "change", lang.hitch(this, this._onChange_Fileinput, buttonContainer, fileupload, data));


            fileupload.startup();


        }

    }

    _onChange_Fileinput(domnode: any, fileupload: any, data: any): void {
        let uploadData = fileupload.getUploadData();
        console.log("_onChange_Fileinput", domnode, uploadData, data);

        domConstruct.empty(domnode);
        if (uploadData) {
            let button = domConstruct.create("button", {
                className: "mds-button-base round accentcolor w3-padding-small mds-hover-bright",
                innerHTML: "Upload&nbsp;<i class='fa fa-upload'></i>"
            }, domnode);

            on(button, "click", lang.hitch(fileupload, "_StartUpload", { taskID: data.ID }));
        }
    }

    _onUploadTaskfileResponse(row: any, response: any): void {
        //console.debug("_onUploadTaskfileResponse", row, [response]);

        //let result = this.employeeTasksTable.updateData([response]);

        //if (result != true) {
        //    alert("upate failed");
        //}

        //let result = this.employeeTasksTable.setData([response]);

        //if (result != true) {
        //    alert("upate failed");
        //}

        this.loadScheduledTaskExecutors(); // nix von da oben geht, Tabulator is einfach gschissn. Forever.

    }

    _onClick_RemoveFile(fileID: any, taskID: any, domnode: any, evt: any): void {
        evt.stopPropagation();

        this.StandbyStart(domnode);

        var url = window.appRoot + "JDM/RemoveTaskFile";

        let data = { "fileID": fileID, "taskID": taskID };

        this.RequestManager.post(
            url,
            {
                jsonData: JSON.stringify(data)
            },
            lang.hitch(this, this._onRemoveTaskFileResponse),
            lang.hitch(this, this._onRemoveTaskFileError),
            false // sync
        );
    }
    _onRemoveTaskFileError(error: any): void {
        console.error(error.Message);
        this.StandbyStop();
    }


    _onRemoveTaskFileResponse(response: any): void {
        this.StandbyStop();

        this.loadScheduledTaskExecutors(); // nix von da oben geht, Tabulator is einfach gschissn. Forever.
    }

    _onClickDownloadFile(fileID: any, evt: any): void {
        evt.stopPropagation();
        //console.debug("_onClickDownloadFile", fileID, evt);

        var url = window.appRoot + "JDM/DownloadTaskFile?ID=" + fileID;
        window.open(url);
    }

    //custom formatter definition
    tableBtnActions(cell: any, formatterParams: any, onRendered: any): any { //plain text value

        var data = cell.getRow().getData();
        var buttonStates = JSON.parse(data.tmp_buttonstates);

        var container = domConstruct.create("div");
        domClass.add(container, "flex_row");
        //console.log("tableBtnActions", data, buttonStates);

        if (buttonStates.button_accept === true) {
            var button = domConstruct.create("button");
            domClass.add(button, "mds-button-base round mds-bg-gray mds-hover-dark zal-table-action-button");
            domAttr.set(button, "innerHTML", "<i class='fas fa-bolt'>&nbsp;</i>" + this.translations["OccurrenceTaskExecutions__TableBtn_Accept"] /*annehmen"*/);
            domAttr.set(button, "title", this.translations["OccurrenceTaskExecutions__TableBtn_AcceptTooltip"]);
            domConstruct.place(button, container);
            on(button, "click", lang.hitch(this, "_onClick__AcceptTask", data));
        }

        if (buttonStates.button_complete === true) {
            var button = domConstruct.create("button");
            domClass.add(button, "mds-button-base round mds-bg-gray mds-hover-dark zal-table-action-button");
            domAttr.set(button, "innerHTML", "<i class='fas fa-check'>&nbsp;</i>" + this.translations["OccurrenceTaskExecutions__TableBtn_Finish"] /*erledigen"*/);
            domAttr.set(button, "title", this.translations["OccurrenceTaskExecutions__TableBtn_FinishTooltip"]);
            domConstruct.place(button, container);
            on(button, "click", lang.hitch(this, "_onClick__CompleteTask", data));
        }

        if (buttonStates.button_pause === true) {
            var button = domConstruct.create("button");
            domClass.add(button, "mds-button-base round mds-bg-gray mds-hover-dark zal-table-action-button");
            domAttr.set(button, "innerHTML", "<i class='fas fa-pause'>&nbsp;</i>" + this.translations["OccurrenceTaskExecutions__TableBtn_Pause"] /*unterbrechen"*/);
            domAttr.set(button, "title", this.translations["OccurrenceTaskExecutions__TableBtn_PauseTooltip"]);
            domConstruct.place(button, container);
            on(button, "click", lang.hitch(this, "_onClick__PauseTask", data));
        }

        if (buttonStates.button_start === true) {
            var button = domConstruct.create("button");
            domClass.add(button, "mds-button-base round mds-bg-gray mds-hover-dark zal-table-action-button");
            domAttr.set(button, "innerHTML", "<i class='fas fa-play'>&nbsp;</i>" + this.translations["OccurrenceTaskExecutions__TableBtn_Start"] /*Bearbeitung starten"*/);
            domAttr.set(button, "title", this.translations["OccurrenceTaskExecutions__TableBtn_StartTooltip"]);
            domConstruct.place(button, container);
            on(button, "click", lang.hitch(this, "_onClick__StartTask", data));
        }

        if (buttonStates.button_maintenance === true) {
            var button = domConstruct.create("button");
            domClass.add(button, "mds-button-base round mds-bg-gray mds-hover-dark zal-table-action-button");
            domAttr.set(button, "innerHTML", "<i class='fas fa-clipboard-list'>&nbsp;</i>" + this.translations["OccurrenceTaskExecutions__TableBtn_Maintenance"] /*Bearbeitung starten"*/);
            domAttr.set(button, "title", this.translations["OccurrenceTaskExecutions__TableBtn_MaintenanceTooltip"]);
            domConstruct.place(button, container);
            on(button, "click", lang.hitch(this, "_onClick__ShowMaintenance", data.ref_Inventar));
        }

        // Button zum Aufklappen der Ausführungen
        if (data.TaskExecutors.length > 0) {
            var button = domConstruct.create("button");
            domClass.add(button, "mds-button-base round w3-center mds-bg-gray mds-hover-dark zal-table-action-button");
            domAttr.set(button, "innerHTML", "<i class='fas fa-caret-down'>&nbsp;</i>" + this.translations["OccurrenceTaskExecutions__TableBtn_ShowEx"]);
            domAttr.set(button, "title", this.translations["OccurrenceTaskExecutions__TableBtn_ShowExTooltip"]);
            domConstruct.place(button, container);
            on(button, "click", lang.hitch(this, "_onClick__ExpandTaskExecutor", data.ID, button));
        }

        return container;

    }


    _onClick__ShowMaintenance(Inventar: any, button?: any): void {

        console.debug("_onClick__ShowMaintenance", Inventar);
        if (Inventar == null || typeof (Inventar) == "undefined") {
            return;
        }

        var dialog: any = new GenericDialog;
        dialog.destroyOnClose = true;
        dialog.closeOnEnter = false;
        domStyle.set(dialog.textNode, "height", "unset");
        //domStyle.set(dialog.textNode, "maxHeight", "unset");
        domStyle.set(dialog.textNode, "overflow", "auto");
        dialog.hideSubtitleNode(true);
        dialog.set("ok", false);
        dialog.set("cancel", false);
        dialog.set("close", true);
        dialog.set("topCloseBtn", true);

        //dialog.set("content", "Hier Freitexteingabe");
        dialog.set("header", this.translations["OccurrenceTaskExecutions__TableBtn_Maintenance"] + " - " + Inventar.tmp_label);


        let maintenanceInfo: any = new MaintenanceInfo;

        maintenanceInfo.set("entity", Inventar);

        dialog.addNodeToContent(maintenanceInfo.domNode);

        dialog.show();
    }

    _onClick__ExpandTaskExecutor(ID: any, button?: any): void {
        //console.log("_onClick__ExpandTaskExecutor", ID, this._executions);
        for (var i = 0; i < this._executions.length; i++) {
            var execution = this._executions[i];
            let file = this._files[i];

            if (execution.ID == ID && execution.node != null) {
                if (domClass.contains(execution.node, "w3-hide")) {
                    domClass.remove(execution.node, "w3-hide");
                    domClass.remove(file.node, "w3-hide");

                    // merken welche Aufträge ausgeklappt waren:
                    if (this._showExecutions.indexOf(ID) == -1) {
                        this._showExecutions.push(ID);
                    }

                    if (typeof (button) != "undefined") {
                        domAttr.set(button, "innerHTML", "<i class='fa fa-caret-up'>&nbsp;</i>" + this.translations["OccurrenceTaskExecutions__TableBtn_HideEx"]);
                        domAttr.set(button, "title", this.translations["OccurrenceTaskExecutions__TableBtn_HideExTooltip"])
                    }
                } else {
                    domClass.add(execution.node, "w3-hide");
                    domClass.add(file.node, "w3-hide");
                    this._showExecutions.splice(this._showExecutions.indexOf(ID), 1);
                    if (typeof (button) != "undefined") {
                        domAttr.set(button, "innerHTML", "<i class='fa fa-caret-down'>&nbsp;</i>" + this.translations["OccurrenceTaskExecutions__TableBtn_ShowEx"]);
                        domAttr.set(button, "title", this.translations["OccurrenceTaskExecutions__TableBtn_ShowExTooltip"]);
                    }
                }
                break;
            }
        }
    }

    showStatusChangeDialog(taskEntity: any, header: any, subtitle: any, callback: any): void {
        var dialog: any = new ExecutionChangeDlg();
        this.executionChangeDlg = dialog;
        dialog.setup(taskEntity, header, subtitle, callback);
        dialog.show();
    }


    _onClick__PauseTask(taskEntity: any): void {
        let header = this.translations["OccurrenceTaskExecutions__DialogPauseHeading"].format(taskEntity.Number);
        let subtitle = this.translations["OccurrenceTaskExecutions__DialogPause"].format(taskEntity.Number);

        this.showStatusChangeDialog(taskEntity,
            header,
            subtitle,
            lang.hitch(this,
                this._changeExecuterStatus,
                taskEntity,
                "ID_scheduled_task_executer_status_pause"
            )
        );

    }

    _onClick__CompleteTask(taskEntity: any): void {

        //dialog.set("SubTitle", "Die Ausführung zu Auftrag " + taskEntity.Number + " wird erledigt und eine Nachricht an den Meldenden geschickt.<br>Möchten Sie eine Anmerkung hinzufügen?");
        //dialog.set("SubTitle", this.translations["OccurrenceTaskExecutions__DialogConfirmFinish"].format(taskEntity.Number));

        let header = this.translations["OccurrenceTaskExecutions__DialogConfirmFinishHeading"].format(taskEntity.Number);
        let subtitle = this.translations["OccurrenceTaskExecutions__DialogConfirmFinish"].format(taskEntity.Number);

        this.showStatusChangeDialog(taskEntity,
            header,
            subtitle,
            lang.hitch(this,
                this._changeExecuterStatus,
                taskEntity,
                "ID_scheduled_task_executer_status_done"
            )
        );


    }

    _onClick__StartTask(taskEntity: any): void {
        //this._changeExecuterStatus(taskEntity, "ID_scheduled_task_executer_status_active");
        let header = this.translations["OccurrenceTaskExecutions__DialogStartHeading"].format(taskEntity.Number);
        let subtitle = this.translations["OccurrenceTaskExecutions__DialogStart"].format(taskEntity.Number);

        this.showStatusChangeDialog(taskEntity,
            header,
            subtitle,
            lang.hitch(this,
                this._changeExecuterStatus,
                taskEntity,
                "ID_scheduled_task_executer_status_pause"
            )
        );
    }

    _changeExecuterStatus(taskEntity: any, targetState: any, result?: any): void {


        console.debug("_changeExecuterStatus", result, taskEntity, data);

        // antwort vom Dialog? (bei Pausieren)
        if (typeof (result) != "undefined") {

            if (result < 1) { // Abbruch
                return;
            }

        } else {
            return;
        }

        var data = this.executionChangeDlg.getData();

        data.targetState = targetState;

        this.StandbyStart();

        var url = window.appRoot + "JDM/ChangeExecuterStatus";

        this.RequestManager.post(
            url,
            {
                taskID: taskEntity.ID,
                jsonData: JSON.stringify(data)
            },
            lang.hitch(this, "_onChangeExecuterStatusResponse"),
            lang.hitch(this, "_onChangeExecuterStatusError"),
            false // sync
        );

    }



    _onChangeExecuterStatusResponse(): void {
        //this.loadScheduledTaskExecutors();
        this.emit("ExecutersChanged");
        this.StandbyStop();

        if (this.executionChangeDlg) {
            setTimeout(domConstruct.destroy(this.executionChangeDlg.domNode), 1000);

            this.executionChangeDlg = null;
        }
    }
    _onChangeExecuterStatusError(error: any): void {
        this.StandbyStop();
        alert(error.Message);

        if (this.executionChangeDlg) {
            this.executionChangeDlg.show();
        }
    }

    _onClick__AcceptTask(taskEntity: any): void {
        this.StandbyStart();

        var url = window.appRoot + "JDM/AcceptTaskJSON";

        this.RequestManager.post(
            url,
            {
                taskID: taskEntity.ID
            },
            lang.hitch(this, "_onChangeExecuterStatusResponse"),
            lang.hitch(this, "_onChangeExecuterStatusError"),
            false // sync
        );
    }
    _onLoadScheduledTaskExecutorsError(error: any): void {
        this.StandbyStop();
    }

    tableFormatterEmployee(cell: any, formatterParams: any, onRendered: any): any {

        var data = cell.getData();
        var value = cell.getValue();

        //console.debug("tableFormatterEmployee", data);

        let rawBGColor = "#fff";

        if (data.ref_employee) {
            if (data.ref_employee.ID == (window as any).sessionInfo.sessionData.CurrentEmployeeId) {
                rawBGColor = "#8aa";
                domStyle.set(cell.getRow().getElement(), "outline", "2px solid " + rawBGColor);
                domStyle.set(cell.getRow().getElement(), "outlineOffset", "-2px");
                domStyle.set(cell.getRow().getElement(), "fontWeight", "bold");
            }
        }


        return value;
    }

    tableFormatterStatus(cell: any, formatterParams: any, onRendered: any): any {

        var data = cell.getData();
        var value = cell.getValue();

        //console.debug("tableFormatterStatus", data);

        let rawColor = null;
        if (data.ref_status) {
            rawColor = data.ref_status.DisplayColor;
        } else if (data.ref_scheduled_task_executer_status) { // bei der Unterliste mit Ausführungen!
            rawColor = data.ref_scheduled_task_executer_status.DisplayColor;
        }

        if (rawColor == null || typeof (rawColor) == "undefined") {
            return value;
        }

        //console.log("occurrenceTaskList tableFormatterStatus color", rawColor, data.ref_status);

        var rawTextColor = "000000";

        if (typeof (rawColor) == "object" && rawColor != null) {

            var hexColor = rawColor.BackColor.Hex;
            domStyle.set(cell.getElement(), "background-color", hexColor);

            hexColor = rawColor.TextColor.Hex;
            domStyle.set(cell.getElement(), "color", hexColor);

        } else {
            var hexColor: any = "#ccc";
            domStyle.set(cell.getElement(), "background-color", hexColor);

            hexColor = "330000";
            domStyle.set(cell.getElement(), "color", hexColor);
        }


        return value;
    }
}
OccurrenceTaskList.prototype.declaredClass = 'WidgetCollection.JDM.Occurrence.OccurrenceTaskList';

export default mdsWidget(OccurrenceTaskList);
